export function  calculateSum(arr)

{
    return arr.reduce((total, current) => {
        return total + current;
    }, 0);
}